module.exports = __webpack_public_path__ + "img/case_03.787e8287.jpg";